<template>
  <div class="main-box" :class="{ isMobile: isMobile }">
    <full-page v-if="!isMobile" ref="fullpage" :options="options" id="fullpage">
      <div class="section" ref="section1">
        <carousel></carousel>
        <staticControl></staticControl>
        <div
          class="paradigm_next_page"
          style="top: 87%; z-index: 1000"
          @click="toPage"
        >
          <i class="iconfont iconjiantou"></i>
        </div>
      </div>
      <div id="section1" class="section animate-box">
        <div class="text-box b-box" style="margin-top: -20px">
          <examsence class="layout"></examsence>
          <div class="paradigm_next_page" style="top: 100%" @click="toPage">
            <i class="iconfont iconjiantou"></i>
          </div>
        </div>
      </div>
      <div id="section2" class="section paradigm_page_bg animate-box">
        <div class="text-box w-box">
          <examintro class="layout"></examintro>
          <div :class="{ paradigm_next_page: true }" @click="toPage">
            <i class="iconfont iconjiantou"></i>
          </div>
        </div>
      </div>
      <div id="section3" class="section paradigm_page_bg animate-box">
        <div class="text-box b-box">
          <interviewintro class="layout"></interviewintro>
          <div :class="{ paradigm_next_page: true }" @click="toPage">
            <i class="iconfont iconjiantou"></i>
          </div>
        </div>
      </div>
      <div class="section fp-auto-height animate-box paradigm_page_bg">
        <div class="text-box w-box">
          <customer class="layout"></customer>
        </div>
      </div>
    </full-page>

    <div class="mobile-box" v-if="isMobile">
      <div class="section">
        <div>
          <carousel></carousel>
        </div>
        <staticControl></staticControl>
      </div>
      <div class="section section-examsence">
        <div class="text-box b-box">
          <examsence></examsence>
        </div>
      </div>
      <div class="section section2 paradigm_page_bg">
        <div class="text-box w-box">
          <examintro></examintro>
        </div>
      </div>
      <div class="paradigm_page_bg">
        <div class="text-box b-box nopadding">
          <interviewintro></interviewintro>
        </div>
      </div>
      <div class="section fp-auto-height paradigm_page_bg">
        <div class="text-box w-box">
          <customer></customer>
        </div>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>

<script>
// https://github.com/alvarotrigo/fullPage.js
import staticControl from '@/components/home/carousel/sitestatic'
import carousel from '@/components/home/carousel'
import examsence from '@/components/home/examsence'
import examintro from '@/components/home/examintro'
import interviewintro from '@/components/home/interviewIntro'
import customer from '@/components/home/customer'
import footbox from '@/components/home/footer'
export default {
  components: {
    staticControl,
    carousel,
    examsence,
    examintro,
    interviewintro,
    customer,
    footbox,
  },
  data() {
    return {
      isMobile: false,
      options: {
        menu: '#menu',
        verticalCentered: true,
        sectionsColor: [
          '#f6f7fd',
          '#f6f7fd',
          '#ffffff',
          '#f6f7fd',
          '#ffffff',
          '#ffffff',
        ],
        afterLoad: this.afterLoad,
      },
      nowIndex: 1,
    }
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
    console.log(this.isMobile, 'dkjfh')
    this.$bus.$off('fullpageTop')
    this.$bus.on('fullpageTop', this.fullpageTop)
  },
  watch: {
    '$store.state.app.nowPage'(now) {
      const fullpage = this.$refs.fullpage
      fullpage.api.moveTo(1)
    },
  },
  methods: {
    fullpageTop() {
      const fullpage = this.$refs.fullpage
      fullpage.api.setAutoScrolling(true)
      fullpage.api.moveTo(1)
    },
    afterLoad(anchorLink, index) {
      let _this = this
      const fullpage = (window.full = this.$refs.fullpage)
      if (index.index == 0) {
        this.$store.dispatch('setRightBar', false)
      } else {
        this.$store.dispatch('setRightBar', true)
      }
      if (fullpage && fullpage.api) {
        if (index.isLast) {
          fullpage.api.setAutoScrolling(false)
          fullpage.api.setFitToSection(false)
          let start = $(document).scrollTop()
          $(document).scroll(function () {
            // 获得页面实时滚动的位置
            let end = $(document).scrollTop()
            // 如滚动的位置小于0，则代表页面在倒数第二屏向上滚，这个时候再改变页面的滚动方式
            if (end - start < 0) {
              if (
                _this.$route.path == '/home' ||
                _this.$route.path == '/product/interview'
              ) {
                fullpage.api.setAutoScrolling(true)
                setTimeout(()=>{
                  fullpage.api.moveTo(4)
                },100)
              }
            }
          })
        }
      }
    },
    toPage() {
      const fullpage = this.$refs.fullpage
      fullpage.api.moveSectionDown()
    },
    hideRightBar() {
      this.$store.state.app.rightBar = false
    },
  },
}
</script>

<style lang="scss" scoped>
.home-box {
  padding-top: 15px;
  width: 1200px;
  margin: 0px auto;
}
.main-box {
  width: 100%;
  overflow-x: hidden;
}

.b-box {
  background: #f7f8fd url('/static/images/bbg.png') repeat-x;
}
.w-box {
  background: #fff url('/static/images/wbg.png') repeat-x;
}
.text-box {
  height: 100%;
  width: 100%;
  position: relative;
  padding: 0px 20px;
}
.isMobile .text-box {
  padding: 20px;
  min-height: 640px;
}
.isMobile .text-box.nopadding {
  padding: 0px;
}
.p20 {
  padding: 20px;
}
#fullpage .section {
  overflow: hidden;
}
#fullpage .section.fp-auto-height {
  overflow: inherit;
}
.main-box .fp-auto-height.paradigm_page_bg {
  background: #fff;
}
.paradigm_next_page {
  border: 3px solid rgba($color: #01c1bc, $alpha: 0.4);
  color: rgba($color: #01c1bc, $alpha: 0.4);
  border-radius: 50%;
  width: 44px;
  height: 44px;
  cursor: pointer;
  position: absolute;
  z-index: 20;
  padding: 5px;
  top: 94%;
  margin-top: -98px;
  left: 50%;
  margin-left: -24px;
  animation: paradigm_next_page_animate 2s linear;
  animation-iteration-count: infinite;
  .iconjiantou {
    font-size: 30px;
  }
}
.layout {
  display: grid;
  height: 100%;
}
</style>
<style lang='scss'>
@media screen and (max-width: 600px) {
  .mobile-box .banner {
    height: 550px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .mobile-box .banner {
    height: 700px !important;
  }
  .section-examsence {
    .text-box {
      min-height: 600px !important;
    }
  }
  .section2 .text-box {
    padding: 20px 120px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue